import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue'
import { message } from 'ant-design-vue'
import { CameraFilled, UploadOutlined, CameraOutlined } from '@ant-design/icons-vue'
import imageCompression from 'browser-image-compression'
import fileTypeChecker from 'file-type-checker'

export interface Props {
  uploadButton?: boolean
  smallUploadButtonWithCounter?: boolean
  allowedExtensions?: string[]
  hiddenExtensions?: string[]
  maxFileSize?: number
  multiple?: boolean
  currentCount?: number
  base64?: boolean
  compressImage?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Uploader',
  props: {
    uploadButton: { type: Boolean, default: false },
    smallUploadButtonWithCounter: { type: Boolean, default: false },
    allowedExtensions: { default: () => ['png', 'jpg', 'jpeg', 'pdf', 'mp4'] },
    hiddenExtensions: { default: () => ['m4v'] },
    maxFileSize: { default: 16 },
    multiple: { type: Boolean, default: true },
    currentCount: { default: 0 },
    base64: { type: Boolean, default: false },
    compressImage: { type: Boolean, default: true }
  },
  emits: ['newFileUploaded'],
  setup(__props: any, { emit }) {

const props = __props as { uploadButton: boolean, smallUploadButtonWithCounter: boolean, allowedExtensions: string[], hiddenExtensions: string[], maxFileSize: number, multiple: boolean, currentCount: number, base64: boolean, compressImage: boolean };



const compressionTypes = ['image/jpeg', 'image/png']

const validExtensions = props.allowedExtensions.concat(props.hiddenExtensions)

async function handleUpload (file: File): Promise<boolean> {
  if (!await isValidFile(file)) {
    return false
  }
  if (props.compressImage && compressionTypes.includes(file.type)) {
    imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1000,
      useWebWorker: true
    }).then((compressedFile) => {
      if (props.base64) {
        getBase64(compressedFile, (base64:string) => {
          emit('newFileUploaded', { name: compressedFile.name.replace(/\.[^/.]+$/, ''), url: base64 })
        })
      } else {
        const newfile = blobToFile(compressedFile, file.name)
        emit('newFileUploaded', newfile)
      }
    })
  } else {
    if (props.base64) {
      getBase64(file, (base64:string) => {
        emit('newFileUploaded', { name: file.name.replace(/\.[^/.]+$/, ''), url: base64 })
      })
    } else {
      emit('newFileUploaded', file)
    }
  }

  return false
}

async function isValidFile (file: File): Promise<boolean> {
  const buffer = await file.arrayBuffer()
  const detectedFile = fileTypeChecker.detectFile(buffer)
  // Validate file type
  if (!hasValidFileType(detectedFile?.extension, validExtensions)) {
    message.error(`Het type ${detectedFile?.extension} wordt niet ondersteund!`)
    return false
  }

  // Validate file size
  if (file.size / 1024 / 1024 > props.maxFileSize) {
    message.error('De maximale bestandsgrootte is ' + props.maxFileSize + 'MB!', 5)
    return false
  }

  return true
}

function getBase64 (img: File, callback:any) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

function blobToFile (blob:Blob, filename:string) {
  return new File([blob], filename, {
    type: blob.type,
    lastModified: Date.now()
  })
}

function hasValidFileType (type: string|undefined, allowedTypes: string[]): boolean {
  if (!type) return false
  return allowedTypes.includes(type)
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (__props.multiple || (!__props.multiple && __props.currentCount === 0))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "uploader-root",
        style: _normalizeStyle({ display: __props.smallUploadButtonWithCounter ? 'inline' : '' })
      }, [
        (__props.uploadButton || __props.smallUploadButtonWithCounter)
          ? (_openBlock(), _createBlock(_component_a_upload, {
              key: 0,
              "show-upload-list": false,
              "before-upload": handleUpload,
              multiple: __props.multiple,
              capture: null
            }, {
              default: _withCtx(() => [
                (__props.uploadButton)
                  ? (_openBlock(), _createBlock(_component_a_button, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UploadOutlined)),
                        _createTextVNode(" Bestanden uploaden")
                      ]),
                      _: 1
                    }))
                  : (__props.smallUploadButtonWithCounter)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        type: __props.currentCount ? 'primary' : '',
                        style: {"margin-right":"4px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CameraOutlined)),
                          _createTextVNode(" " + _toDisplayString(__props.currentCount || ''), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["multiple"]))
          : (_openBlock(), _createBlock(_component_a_upload_dragger, {
              key: 1,
              class: "uploader",
              "show-upload-list": false,
              "before-upload": handleUpload,
              multiple: __props.multiple,
              capture: null
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CameraFilled), { style: {"font-size":"36px","color":"#f38929","margin":"16px 0"} })
              ]),
              _: 1
            }, 8, ["multiple"])),
        (__props.currentCount && !__props.smallUploadButtonWithCounter)
          ? (_openBlock(), _createBlock(_component_a_divider, { key: 2 }))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}
}

})